var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket__price" },
    [
      _c("span", { staticClass: "ticket__priceAmount" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm._f("formatPrice")(_vm.ticketConfiguration.product.price)
            ) +
            " " +
            _vm._s(_vm.$t("ticketList.ticketConfiguration.currency")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.onSiteProducts &&
      (_vm.onSiteProducts.helpdesk || _vm.onSiteProducts.sb)
        ? [
            _c(
              "span",
              { staticClass: "ticket__priceLabel" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("ticketList.ticketConfiguration.onSitePrice")
                    ) +
                    "\n      "
                ),
                _vm.onSiteProducts.sb
                  ? [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatPrice")(_vm.onSiteProducts.sb.price)
                          ) +
                          " " +
                          _vm._s(
                            _vm.$t("ticketList.ticketConfiguration.currency")
                          ) +
                          "\n      "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatPrice")(
                              _vm.onSiteProducts.helpdesk.price
                            )
                          ) +
                          " " +
                          _vm._s(
                            _vm.$t("ticketList.ticketConfiguration.currency")
                          ) +
                          "\n      "
                      ),
                    ],
              ],
              2
            ),
          ]
        : [
            _c("span", { staticClass: "ticket__priceLabel" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("ticketList.ticketConfiguration.noOnSiteSale")
                  ) +
                  "\n    "
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }